import { DateUtilService } from '../date-utils';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { WebapiService } from '../webapi.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { PreloaderService } from '../preloader.service';


@Component({
  selector: 'app-checks',
  templateUrl: './checks.component.html',
  styleUrls: ['./checks.component.scss']
})
export class ChecksComponent implements OnInit, OnDestroy {
   filter:any={};
   smallModalContent: any ;
  total: any;
  p:number = 1;
  checkList: any;
  checkListV2: any;
  countList:any= {};
  loginType:any;
  teamName:any
  openCounter: boolean;
  multiple:any=[];
  proofMultiple:any=[];
  imageArr:any=[];
  imageUrl: any;
  statusArr: any =[];
  finalStatusArr: any=[];
  filterData:any={}
  clientList: any;
  openProofCounter: boolean;
  proofData:any={};
  imageProofArr: { serverName: string; originalName: string }[] = [];
  
  // Unified array for editable proof documents supporting reordering
  combinedProofDocs: { serverName: string, originalName: string, isNew: boolean }[] = [];
  dragStartItemIndex: number | null = null;
  dragOverItemIndex: number | null = null;

  onDragStart(index: number) {
    this.dragStartItemIndex = index;
  }

  onDragOver(event: DragEvent, index: number) {
    event.preventDefault(); // Necessary to allow dropping
    this.dragOverItemIndex = index;
  }

  onDragLeave() {
    this.dragOverItemIndex = null;
  }

  onDrop(event: DragEvent, dropIndex: number) {
    event.preventDefault();
    if (this.dragStartItemIndex !== null && this.dragStartItemIndex !== dropIndex) {
      const movedItem = this.combinedProofDocs[this.dragStartItemIndex];
      this.combinedProofDocs.splice(this.dragStartItemIndex, 1);
      this.combinedProofDocs.splice(dropIndex, 0, movedItem);
    }
    this.dragStartItemIndex = null;
    this.dragOverItemIndex = null;
  }

  /** Strips the timestamp prefix from a server filename to get a readable display name.
   *  e.g. "image_1774761494545.jpg" → "image.jpg", or uses originalName if available */
  getOriginalName(serverName: string): string {
    // Server renames files as: <baseName>_<timestamp>.<ext>
    const match = serverName.match(/^(.+?)_(\d{10,})(\.\w+)$/);
    if (match) return match[1] + match[3]; // base + ext
    return serverName;
  }
  loginId: any;
  fileString: any;
  pdfCounter: boolean = false;
  imageCounter: boolean = false;
  s3Url: string='';
  currentDocumentName: string = 'Document';
  currentFileUrl: string = '';
  modalRef: NgbModalRef | null = null;
  constructor(public dateUtil: DateUtilService, private WebApiService:WebapiService,private activatedRoute:ActivatedRoute,
    private router:Router,private modalService: NgbModal,private sanitizer: DomSanitizer,private spinner:PreloaderService) {
    this.statusArr = ['DRAFT','NEW','INPROGRESS','QC','COMPLETED','STOPPED','CURRENT EMPLOYMENT'];
      this.imageUrl = this.WebApiService.imageUrl;
      this.s3Url = this.WebApiService.s3Url;
     }
    applicationList: any;
    candidate: any;
    logList: any=[];

    ngOnDestroy(): void {
      sessionStorage.removeItem('activeAppId');
      sessionStorage.removeItem('activeCheckName');
      sessionStorage.removeItem('activeSearch');
    }

    ngOnInit(): void {
      this.loginId = sessionStorage.getItem('loginId');
      this.loginType = sessionStorage.getItem('type');
      this.teamName = sessionStorage.getItem('teamName');
      this.multiple = [
        {
          file:""
        }
      ]
      this.proofMultiple = [
        {
          file:""
        }
      ]
      this.filter = {
        pageNo:1,
        size:10,
        status:'',
        search: sessionStorage.getItem('activeSearch') || '',
        clientId:'',
        created:'',
        assignProcess:''
      }

      if (this.filter.search) {
        this.searchCheck(null);
      } else {
        if(this.loginType == 1){
          this.getAllApplication();
          this.getApplications();
        }
        else if(this.loginType == 4 && this.teamName == "Case Initiation Team"){
          this.filter.perm = 'all'
          this.getAllApplicationV2();
          this.getApplicationsInit();

        }
        else if(this.loginType ==4 && this.teamName == "Processing Team"){
          this.getAllApplicationByEmp();
          this.getApplicationsEmp();

        }
        else if(this.loginType == 3){
          this.filter.clientId = this.loginId;
          this.getAllApplication();
          this.getApplications();
        }
        else if(this.loginType == 6){
          let process = sessionStorage.getItem("assignProcess");
          // this.filter.assignProcess = process;
          this.filter.assignTo = this.loginId;
          this.getAllApplication();
          this.getApplications();
        }
        else if(this.loginType == 7){
          let client = sessionStorage.getItem("addedId");
          let process = sessionStorage.getItem("assignProcess");
          // this.filter.assignProcess = process ;
          this.filter.assignTo = this.loginId;
          this.getAllApplication();
          this.getApplications();
        }
      }
      this.getClient();

    }

    openSmallModal( smallModalContent ) {
      this.modalService.open( smallModalContent, { size : 'sm' } );
    }

    isArray(value:[]):boolean {
      return Array.isArray(value);
    }
    containsProof(str:''):boolean {
      return str.includes('.proof');
    }
    getKeys(obj: object): string[] {
      return Object.keys(obj);
    }

    loadSelectedOrDefault() {
      if (!this.applicationList || this.applicationList.length === 0) return;
      let activeAppId = sessionStorage.getItem('activeAppId');
      let activeCheckName = sessionStorage.getItem('activeCheckName');

      if (activeAppId && activeCheckName) {
        this.getAppById(activeAppId, activeCheckName);
      } else {
        if (this.applicationList[0] && this.applicationList[0].checksData && this.applicationList[0].checksData.length > 0) {
          this.getAppById(this.applicationList[0]._id, this.applicationList[0].checksData[0].checkName);
        }
      }
    }

    getAllApplication(){
      this.WebApiService.getAllApplication(this.filter).subscribe((res:any)=>{
        this.applicationList = res.data;
        this.total = res.total;
        let arr =[];
        for(let key of this.applicationList){
          for (const it of key.checksData) {
            it.appData = key;
            arr.push(it);
          }
        }
        this.checkList = arr;
        this.loadSelectedOrDefault();
      })
    }

    getAllApplicationV2(){
      this.WebApiService.getAllApplicationInit(this.filter).subscribe((res:any)=>{
      //  console.log(res);
      this.applicationList = res.data;
      this.total = res.total;
      let arr =[];
      for(let key of this.applicationList){
        for (const it of key.checksData) {
          it.appData = key;
          arr.push(it);
        }
      }
      this.checkList = arr;
      this.loadSelectedOrDefault();

      })
    }

    getClient() {
      this.WebApiService.getAllClient().subscribe((res: any) => {
        this.clientList = res.user;
      });
    }

    getClientName(clientId: any): string {
      if (!clientId) return '';
      if (clientId.name) return clientId.name;
      let id = typeof clientId === 'string' ? clientId : clientId._id;
      if (this.clientList && this.clientList.length > 0) {
        let match = this.clientList.find((c: any) => c._id === id);
        if (match) return match.name;
      }
      return '';
    }

  getAllApplicationByEmp(){
    this.WebApiService.getAllApplicationByEmp(this.filter).subscribe((res:any)=>{
      this.applicationList = res.data;
      this.total = res.total;
      let arr =[];
      for(let key of this.applicationList){
        for (const it of key.checksData) {
          it.appData = key;
          arr.push(it);
        }
      }
      this.checkList = arr;
      this.loadSelectedOrDefault();
    })
  }

    getStatusWiseCheck(status:any){
      this.filter.status = status;
   this.WebApiService.getCheckByStatus(this.filter).subscribe((res:any)=>{
   this.applicationList =res.data
   this.total = res.total
       let arr =[];
      for(let key of this.applicationList){
       for (const it of key.checksData) {
         it.appData = key;
         if(it.status == status){
          arr.push(it);
         }
       }
      this.checkList = arr;
      }
      this.loadSelectedOrDefault();
   });

    }

    setStatus(e:any,data:any,checkName:any,id:any){
      let index = data.findIndex(x=>x.checkName == checkName);
      if(index >= 0){
        data[index].status = e.target.value;
        if(e.target.value == 'COMPLETED'){
          data[index].completed = new Date();
        }
      }

      let obj: any = {};
      let arr = data.map((it: any) => {
        let newItem = { ...it };
        delete newItem.appData;
        return newItem;
      });
      obj['_id'] = id;
      obj['checksData'] = arr;
      obj['performBy'] = this.loginId;
      this.WebApiService.insertApplication(obj).subscribe((res: any) => {
      
      if(res.status == "ok"){
        alert(res.msg);
        const activeSearch = sessionStorage.getItem('activeSearch');
        if (activeSearch) {
          this.searchCheck(null);
        } else {
          if(this.loginType == 1){
            this.getAllApplication();
          }
          if(this.loginType == 4 && this.teamName == "Case Initiation Team"){
            this.getAllApplicationV2();
          }
          if(this.loginType == 4){
            this.getAllApplicationByEmp();
          }
        }
      }
      else{
        alert(res.msg);
      }
      })
    }

    formatDateV2(dateString:any){
      const date = new Date(dateString);

      // Convert to IST (UTC + 5:30)
      const istOffset = 5.5 * 60 * 60 * 1000; // Offset in milliseconds
      const istDate = new Date(date.getTime() - istOffset);

      // Format the date parts
      const day = String(istDate.getDate()).padStart(2, '0');
      const month = String(istDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const year = istDate.getFullYear();
      const hours = String(istDate.getHours()).padStart(2, '0');
      const minutes = String(istDate.getMinutes()).padStart(2, '0');

      // Return formatted string
      return `${day}/${month}/${year}, ${hours}:${minutes}`;
    }

    getAppById(id:any,checkName:any){
      sessionStorage.setItem('activeAppId', id);
      sessionStorage.setItem('activeCheckName', checkName);

      this.WebApiService.getAppById(id).subscribe((res:any)=>{
        //  console.log(res,'--');
       this.candidate = res.data;

       // Fix: The getAppById API might not strictly populate the 'clientId.name' object.
       // This maps it if it's returning a raw string ID, so the pinned left-side UI button renders perfectly.
       if (this.candidate.clientId) {
         if (typeof this.candidate.clientId === 'string' || !this.candidate.clientId.name) {
           let cid = typeof this.candidate.clientId === 'string' ? this.candidate.clientId : this.candidate.clientId._id;
           if (this.clientList && this.clientList.length > 0) {
             let match = this.clientList.find((c: any) => c._id === cid);
             if (match) {
               this.candidate.clientId = match;
             }
           }
         }
       }

     this.logList = res.logs;

       let arr =[];
        for (const it of this.candidate.checksData) {
          it.appData = this.candidate;
          if(it.checkName == checkName){
            arr.push(it);
          }
        }
       this.checkListV2 = arr;
       console.log(this.checkListV2,'--');

       // Check if the current list contains the active item. If not, unshift it to the top!
       if (this.checkList && this.checkList.length > 0 && this.checkListV2 && this.checkListV2.length > 0) {
         let existsInList = this.checkList.some((item: any) => item.appData?._id === id && item.checkName === checkName);
         if (!existsInList) {
           this.checkList.unshift(this.checkListV2[0]);
         }
       }

       let shCopy = this.statusArr.slice();
       let index = shCopy.indexOf(this.checkListV2[0]?.status);
       if(index >= 0){
        shCopy.splice(index, 1)
        this.finalStatusArr = shCopy;
       }
       else{
        this.finalStatusArr = this.statusArr;
       }

        })
    }

    onTableDataChange(event: any) {
      this.filter.pageNo = event;
      if(this.loginType == 1){
        if(this.filter.status){
          this.getStatusWiseCheck(this.filter.status);
        }
        else{
          this.getAllApplication();
        }
      }
      if(this.loginType == 3){
        if(this.filter.status){
          this.getStatusWiseCheck(this.filter.status);
        }
        else{
          this.getAllApplication();
        }
      }
      if(this.loginType == 4 && this.teamName == "Case Initiation Team"){
        if(this.filter.status){
          this.getStatusWiseCheck(this.filter.status);
        }
        else{
          this.getAllApplicationV2();
        }
      }
      if(this.loginType == 4){
        if(this.filter.status){
          this.getStatusWiseCheck(this.filter.status);
        }
        else{
          this.getAllApplicationByEmp();
        }
      }
      this.p = event;
    //   window.scrollTo({
    //    top: 0,
    //    behavior: 'smooth'
    //  });
   }

   openForm(){
    this.openCounter = true;
   }

   saveData(data: any, checkName: any) {
    if (!Array.isArray(data) || !data.length) {
      console.error("Invalid or empty data array");
      return;
    }
  
    this.spinner.show(); // Start spinner
    const firstItem = data[0];
  
    // Ensure checkDoc is handled correctly
    if (Array.isArray(firstItem.checkDoc)) {
      firstItem.checkDoc = [...firstItem.checkDoc, ...this.imageArr];
    } else {
      firstItem.checkDoc = [...this.imageArr];
    }
  
    // Prepare payload
    const appData = firstItem.appData;
    if (!appData || !Array.isArray(appData.checksData)) {
      console.error("Invalid appData or checksData");
      this.spinner.hide();
      return;
    }
  
    const checksData = appData.checksData.map((item: any) => {
      const newItem = { ...item };
      delete newItem.appData;
      return newItem;
    });
  
    const obj: any = {
      _id: appData._id,
      checksData: checksData,
      performBy: this.loginId,
    };
  
    // API call
    this.WebApiService.insertApplication(obj).subscribe(
      (res: any) => {
        this.spinner.hide(); // Stop spinner
  
        if (res.status === "ok") {
          alert(res.msg);
            this.openCounter = false;
          this.imageArr = [];
        } else {
          alert(res.msg || "Something went wrong.");
        }
      },
      (error: any) => {
        this.spinner.hide(); // Stop spinner even on error
        console.error("API Error:", error);
        alert("Server error occurred. Please try again.");
      }
    );
  }

  
  //  saveData(data:any,checkName:any){
  //   // console.log(data);
  //   // return
  //   if(data[0]?.checkDoc && data[0]?.checkDoc.length > 0){
  //     data[0].checkDoc = [...data[0]?.checkDoc,...this.imageArr];
  //   }
  //   else{
  //     data[0].checkDoc = this.imageArr;
  //   }
  //    let obj = {};
  //    let arr = [...data[0].appData.checksData];
  //    obj['_id'] = data[0].appData._id;
  //    for (const it of arr) {
  //      delete it.appData
  //    }
  //    obj['checksData'] = arr;
  //    obj['performBy'] = this.loginId;
  //   //  console.log(obj,'--');

  //    this.WebApiService.insertApplication(obj).subscribe((res: any) => {
  //     
  //     if(res.status == "ok"){
  //       alert(res.msg);
  //       if(this.loginType == 1){
  //         this.openCounter = false;
  //       }
  //       if(this.loginType == 4 && this.teamName == "Case Initiation Team"){
  //         this.openCounter = false;

  //       }
  //       if(this.loginType == 4){
  //         this.openCounter = false;

  //       }
  //       this.imageArr = [];

  //     }
  //     else{
  //       alert(res.msg);
  //     }

  //   });
  //  }
   closeForm(){
    this.openCounter = false;
   }

   getApplications(){
    this.WebApiService.getApplications(this.filter).subscribe((res:any)=>{
    
    let arr =[];
    for(let key of res.data){
     for (const it of key.checksData) {
       it.appData = key;
       arr.push(it);
     }
    }
    const newCount = arr.filter(x=>x.status == "NEW")
    const draftCount = arr.filter(x=>x.status == "DRAFT")
    const inprogressCount = arr.filter(x=>x.status == "INPROGRESS")
    const completedCount = arr.filter(x=>x.status == "COMPLETED")
    const stoppedCount = arr.filter(x=>x.status == "STOPPED")
    const qcCount = arr.filter(x=>x.status == "QC")
    // const cekCount = arr.filter(x=>x.status == "CURRENT EMPLOYMENT")

    this.countList = {
      all:arr.length,
      new:newCount.length,
      draft:draftCount.length,
      inprogress:inprogressCount.length,
      completed:completedCount.length,
      stopped:stoppedCount.length,
      qc:qcCount.length
    }
    })
  }

  getApplicationsInit(){
    this.WebApiService.getApplicationsInit(this.filter).subscribe((res:any)=>{
    
    let arr =[];
    for(let key of res.data){
     for (const it of key.checksData) {
       it.appData = key;
       arr.push(it);
     }
    }
    const newCount = arr.filter(x=>x.status == "NEW")
    const draftCount = arr.filter(x=>x.status == "DRAFT")
    const inprogressCount = arr.filter(x=>x.status == "INPROGRESS")
    const completedCount = arr.filter(x=>x.status == "COMPLETED")
    const stoppedCount = arr.filter(x=>x.status == "STOPPED")
    const qcCount = arr.filter(x=>x.status == "QC")

    this.countList = {
      all:arr.length,
      new:newCount.length,
      draft:draftCount.length,
      inprogress:inprogressCount.length,
      completed:completedCount.length,
      stopped:stoppedCount.length,
      qc:qcCount.length
    }
    })
  }

  getApplicationsEmp(){
    this.WebApiService.getApplicationsEmp(this.filter).subscribe((res:any)=>{
    let arr =[];
    for(let key of res.data){
     for (const it of key.checksData) {
       it.appData = key;
       arr.push(it);
     }
    }

    const newCount = arr.filter(x=>x.status == "NEW")
    const draftCount = arr.filter(x=>x.status == "DRAFT")
    const inprogressCount = arr.filter(x=>x.status == "INPROGRESS")
    const completedCount = arr.filter(x=>x.status == "COMPLETED")
    const stoppedCount = arr.filter(x=>x.status == "STOPPED")
    const qcCount = arr.filter(x=>x.status == "QC")

    this.countList = {
      all:arr.length,
      new:newCount.length,
      draft:draftCount.length,
      inprogress:inprogressCount.length,
      completed:completedCount.length,
      stopped:stoppedCount.length,
      qc:qcCount.length
    }
    })
  }

  // uploadDocs(e:any,check:any){
  //   const formData = new FormData();
  //   formData.append('image',e.target.files[0]);
  //   formData.append('type','return');
  //   this.WebApiService.uploadImage(formData).subscribe((res: any) => {
  //      if(res.status == "ok"){
  //        alert('Uploaded file successfully');
  //        this.imageArr.push(res.imageName);
  //       }
  //       else{
  //        alert("something went wrong")
  //       }
  //    });
  // }

  uploadDocs(event: any, check: any, index: number) {
    const file = event.target.files[0];
    if (!file) return;
  
    const formData = new FormData();
    formData.append('image', file);
    formData.append('type', 'return');
  
    this.WebApiService.uploadImage(formData).subscribe((res: any) => {
      if (res.status === "ok") {
        alert('Uploaded file successfully');
        
        // Set or replace the image at the correct index
        this.imageArr[index] = res.imageName;
        
      } else {
        alert("Something went wrong");
      }
    }, (error: any) => {
      console.error("Upload failed:", error);
      alert("Upload failed. Please try again.");
    });
  }

  getImageUrl(imageName: string): string {
    return `${this.imageUrl}${imageName}`; // <- replace this with your real base URL
  }

  searchCheck(e:any){
    if (e && e.target && typeof e.target.value !== 'undefined') {
      sessionStorage.removeItem('activeAppId');
      sessionStorage.removeItem('activeCheckName');
      this.filter.search = e.target.value;
    }

    sessionStorage.setItem('activeSearch', this.filter.search || '');

    if(this.filter.search){
     this.WebApiService.getCheckBySearch(this.filter).subscribe((res:any)=>{
      console.log(res.total[0].total,'---');

      this.applicationList = res.data;
      this.total = res.total;
      let arr =[];
      for(let key of this.applicationList){
        for (const it of key.checksData) {
          it.appData = key;
          arr.push(it);
        }
      }
      this.checkList = arr;
      this.loadSelectedOrDefault();
         const newCount = arr.filter(x=>x.status == "NEW")
         const draftCount = arr.filter(x=>x.status == "DRAFT")
         const inprogressCount = arr.filter(x=>x.status == "INPROGRESS")
         const completedCount = arr.filter(x=>x.status == "COMPLETED")
         const stoppedCount = arr.filter(x=>x.status == "STOPPED")
         const holdCount = arr.filter(x=>x.status == "HOLD")

         this.countList = {
           all:res.total[0].total,
           new:newCount.length,
           draft:draftCount.length,
           inprogress:inprogressCount.length,
           completed:completedCount.length,
           stopped:stoppedCount.length,
           hold:holdCount.length
         }
       })
  }
  else{
    if(this.loginType == 1){
      this.getAllApplication();
      this.getApplications();
    }
    else if(this.loginType == 4 && this.teamName == "Case Initiation Team"){
      this.getAllApplicationV2();
      this.getApplicationsInit();

    }
    else if(this.loginType ==4 && this.teamName == "Processing Team"){
      this.getAllApplicationByEmp();
      this.getApplicationsEmp();

    }
  }
}

  applyFilter(data:any){
    sessionStorage.removeItem('activeAppId');
    sessionStorage.removeItem('activeCheckName');
    this.filter.clientId = data.clientId;
    this.filter.created = data.created;
    this.WebApiService.getCheckByFilter(this.filter).subscribe((res:any)=>{
      this.applicationList = res.data;
      this.total = res.total;
     if(res.data.length > 0){
      let arr =[];
      for(let key of this.applicationList){
        for (const it of key.checksData) {
          it.appData = key;
          arr.push(it);
        }
      }
      this.checkList = arr;
      this.loadSelectedOrDefault();
         const newCount = arr.filter(x=>x.status == "NEW")
         const draftCount = arr.filter(x=>x.status == "DRAFT")
         const inprogressCount = arr.filter(x=>x.status == "INPROGRESS")
         const completedCount = arr.filter(x=>x.status == "COMPLETED")
         const stoppedCount = arr.filter(x=>x.status == "STOPPED")
         const holdCount = arr.filter(x=>x.status == "HOLD")

         this.countList = {
           all:res.total,
           new:newCount.length,
           draft:draftCount.length,
           inprogress:inprogressCount.length,
           completed:completedCount.length,
           stopped:stoppedCount.length,
           hold:holdCount.length
         }
     }
     else{
      this.checkList = [];
      this.checkListV2 = [];
        this.countList = {
        all:0,
        new:0,
        draft:0,
        inprogress:0,
        completed:0,
        stopped:0,
        hold:0
      }
     }
    })
  }

  addMoreUpload(){
    this.multiple.push({});
  }
  addMoreProofUpload(){
    this.proofMultiple.push({});
  }

  resetFilter(){
    this.filterData = {};
  }

  editProof(data:any){
    console.log(data,'---');
    if(data[0].proof){
      this.proofData = data[0]?.proof;
    }
    this.openProofCounter = true;
    
    // Populate the unified array with existing docs
    this.combinedProofDocs = [];
    if (data[0]?.proof?.doc && Array.isArray(data[0].proof.doc)) {
      this.combinedProofDocs = data[0].proof.doc.map((d: any) => ({
        serverName: d,
        originalName: this.getOriginalName(d),
        isNew: false
      }));
    }
  }

  // uploadProofDocs(e:any,check:any){
  //   const formData = new FormData();
  //   formData.append('image',e.target.files[0]);
  //   formData.append('type','return');
  //   this.WebApiService.uploadImage(formData).subscribe((res: any) => {
  //      if(res.status == "ok"){
  //        alert('Uploaded file successfully');
  //        this.imageProofArr.push(res.imageName);
  //       }
  //       else{
  //        alert("something went wrong")
  //       }
  //    });
  // }

  uploadProofDocs(event: any, check: any, index: number) {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;

    if (files.length > 4) {
      alert('You can select a maximum of 4 files at once.');
      event.target.value = '';
      return;
    }

    let uploadedCount = 0;
    let failedCount = 0;
    const total = files.length;

    Array.from(files).forEach((file: File) => {
      const originalName = file.name; // capture original filename before upload
      const formData = new FormData();
      formData.append('image', file);
      formData.append('type', 'return');

      this.WebApiService.uploadImage(formData).subscribe((res: any) => {
        if (res.status === 'ok') {
          this.combinedProofDocs.push({ serverName: res.imageName, originalName, isNew: true });
          uploadedCount++;
        } else {
          failedCount++;
        }

        // Show summary alert only after all uploads finish
        if (uploadedCount + failedCount === total) {
          if (failedCount === 0) {
            alert(`${uploadedCount} file(s) uploaded successfully.`);
          } else {
            alert(`${uploadedCount} uploaded, ${failedCount} failed.`);
          }
          event.target.value = ''; // Reset input
        }
      }, (error: any) => {
        failedCount++;
        console.error('Upload failed:', error);
        if (uploadedCount + failedCount === total) {
          alert(`${uploadedCount} uploaded, ${failedCount} failed.`);
          event.target.value = '';
        }
      });
    });
  }

  saveProofData(data: any, objdata: any, checkname: any) {
    if (!Array.isArray(data) || !data.length) {
      console.error("Invalid or empty data array");
      return;
    }
  
    this.spinner.show();
    this.proofMultiple = [];
  
    const firstItem = data[0];
  
    // Make sure proof object exists
    firstItem.proof = firstItem.proof || {};
    
    // Update proof
    firstItem.proof = objdata || {};
  
    // Use the rearranged combined array sequence as truth
    firstItem.proof.doc = this.combinedProofDocs.map(item => item.serverName);
  
    // Prepare payload for API
    const appData = firstItem.appData;
    if (!appData || !Array.isArray(appData.checksData)) {
      console.error("Invalid appData or checksData");
      this.spinner.hide();
      return;
    }
  
    const arr = appData.checksData.map((it: any) => {
      const newItem = { ...it };
      delete newItem.appData;
      return newItem;
    });
  
    const obj: any = {
      _id: appData._id,
      checksData: arr,
      performBy: this.loginId,
    };
  
    // Call API
    this.WebApiService.insertApplication(obj).subscribe(
      (res: any) => {
        this.spinner.hide();
        
        if (res.status === "ok") {
          alert(res.msg);
  
          if (this.loginType === 1) {
            this.getAllApplication();
          }
  
          if (this.loginType === 4) {
            if (this.teamName === "Case Initiation Team") {
              this.getAllApplicationV2();
            } else {
              this.getAllApplicationByEmp();
            }

          }
          this.openProofCounter = false;
          this.combinedProofDocs = [];
        } else {
          alert(res.msg || "Something went wrong.");
        }
      },
      (error: any) => {
        this.spinner.hide();
        console.error("API Error:", error);
        alert("Server error occurred. Please try again.");
      }
    );
  }

  
  // saveProofData(data:any,objdata:any,checkname:any){
  //   // this.spinner.show();
  //   this.proofMultiple = [];
    
  //  data[0].proof = objdata;
  //  if(data[0]?.proof?.doc && data[0]?.proof?.doc.length > 0){
  //   data[0].proof.doc = [...data[0]?.proof.doc,...this.imageProofArr];
  // }
  // else{
  //   data[0].proof.doc = this.imageProofArr;
  // }
  // // return
  //  let obj = {};
  //  let arr = [...data[0].appData?.checksData];
  //  obj['_id'] = data[0].appData?._id;
  //  for (const it of arr) {
  //    delete it?.appData
  //  }
  //  obj['checksData'] = arr;
  //  obj['performBy'] = this.loginId;
  // //  console.log(data);
  // //  return
  //  this.WebApiService.insertApplication(obj).subscribe((res: any) => {
  //   
  //   if(res.status == "ok"){
  //   this.spinner.hide();
  //     alert(res.msg);
  //     if(this.loginType == 1){
  //       this.getAllApplication();
  //       this.openProofCounter = false;
  //     }
  //     if(this.loginType == 4 && this.teamName == "Case Initiation Team"){
  //       this.getAllApplicationV2();
  //       this.openProofCounter = false;

  //     }
  //     if(this.loginType == 4){
  //       this.getAllApplicationByEmp();
  //       this.openProofCounter = false;

  //     }
  //     this.imageProofArr = [];
  //   }
  //   else{
  //     this.spinner.hide();
  //     alert(res.msg);
  //   }

  // });
  // }
  closeProofForm(){
    this.openProofCounter = false;
  }

  getImage(name:any,mdl:any){
    if (this.modalRef) {
      this.modalRef.dismiss();
    }
    this.currentDocumentName = name;
    this.modalRef = this.modalService.open(mdl, { windowClass: 'custom-left-modal', backdrop: false, keyboard: false });
    let url = `${this.imageUrl}${name}`;
    this.currentFileUrl = url;
    this.fileString = '';
    if(name.includes('.pdf')){
      this.pdfCounter = true;
      this.imageCounter = false;
      this.fileString = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
    else if(name.includes('.jpg') || name.includes('.jpeg') || name.includes('.JPG') || name.includes('.JPEG') || name.includes('.png') || name.includes('.PNG') ){
      this.imageCounter = true;
      this.pdfCounter = false
      this.fileString = url;
    }

  }

  openInNewTab() {
    if (this.currentFileUrl) {
      window.open(this.currentFileUrl, '_blank');
    }
  }

  removeDocCheck(img:any,index:any,data:any){
    let conf = confirm("Are you sure you want to delete")

    if(conf){
       data[0].checkDoc.splice(index,1);
      let obj: any = {};
      let arr = data[0].appData.checksData.map((it: any) => {
        let newItem = { ...it };
        delete newItem.appData;
        return newItem;
      });
      obj['_id'] = data[0].appData._id;
      obj['checksData'] = arr;
      obj['performBy'] = this.loginId;
      this.WebApiService.insertApplication(obj).subscribe((res: any) => {
       
       if(res.status == "ok"){
         alert(res.msg);
       }
       else{
         alert(res.msg);
       }

     });
    }

  }

  removeDocProofCheck(img:any,index:any,data:any){
    let conf = confirm("Are you sure you want to delete")

    if(conf){
      // 1. Fix UI: splice from the unified view array
      if (this.combinedProofDocs && this.combinedProofDocs.length > index) {
        this.combinedProofDocs.splice(index, 1);
      }
      
      // 2. Safely sync the underlying data array to match the unified view
      if (data[0] && data[0].proof) {
        data[0].proof.doc = this.combinedProofDocs.map((item: any) => item.serverName);
      }

      let obj: any = {};
      let arr = data[0].appData.checksData.map((it: any) => {
        let newItem = { ...it };
        delete newItem.appData;
        return newItem;
      });
      obj['_id'] = data[0].appData._id;
      obj['checksData'] = arr;
      obj['performBy'] = this.loginId;
      this.WebApiService.insertApplication(obj).subscribe((res: any) => {
       
       if(res.status == "ok"){
         alert(res.msg);
       }
       else{
         alert(res.msg);
       }

     });
    }



  }

}
